/**
 * File: useRoleHomeController.ts
 * Path: apps/admin/src/features/dashboard/hooks/useRoleHomeController.ts
 * Description: The start page for roles without analytics: their role and the pages their role may open.
 */

import { ADMIN_PATHS, SIDEBAR_ITEMS, visibleNavItems } from "@idk/config";
import { useRole } from "@/modules/auth/hooks/useRoleQueries";

export const useRoleHomeController = () => {
  const { role, can } = useRole();
  const links = visibleNavItems(SIDEBAR_ITEMS, can)
    .flatMap((item) => item.children ?? [item])
    .filter((item) => item.href && item.href !== ADMIN_PATHS.dashboard);
  return { role, links };
};
